import { fetchUrl } from '@dhi/react-components';
import { Diagnostics } from '../interfaces/Config';
import { AutomoorResponse, EnvironmentalConditions, Mooring, Port, Vessel } from '../interfaces/VesselScenario';
import { AppStateStore } from '../stores';

export interface NearestVesselDistance {
  scenarioId: string;
  distance: number;
}

/**
 * Fetch autoMooring result based on mooring.
 * @param appStateStore
 * @param connection
 * @param successCallback
 */
export const calculateAutoMooring = (
  appStateStore: AppStateStore,
  scenarioId: string,
  autoMoorRequest: {
    mooringSetup: { port: Port; vessel: Vessel; mooring: Mooring; environmentalConditions: EnvironmentalConditions };
    nearestVesselDistances: NearestVesselDistance[];
  },
  diagnostics: Diagnostics,
  successCallback: (results: AutomoorResponse) => void,
  errorCallback: () => void,
) => {
  const payload = JSON.stringify({
    eventId: scenarioId,
    ...autoMoorRequest,
  });

  if (diagnostics.autoMooring) {
    console.time('AutomoorProfiling_RequestOnly');
  }

  appStateStore.pendingAutomoorRequests++;

  fetchUrl(`${process.env.REACT_APP_API_MA_ENDPOINT_URL}/api/AutoMooring`, {
    method: 'POST',
    body: payload,
    additionalHeaders: {
      Authorization: `Bearer ${appStateStore.session.token.accessToken}`,
    },
  }).subscribe(
    (result) => {
      appStateStore.pendingAutomoorRequests--;

      if (diagnostics.autoMooring) {
        console.timeEnd('AutomoorProfiling_RequestOnly');
      }

      if (successCallback) {
        successCallback(result);
      }
    },
    (error) => {
      appStateStore.pendingAutomoorRequests--;
      if (appStateStore.pendingAutomoorRequests === 0) {
        appStateStore.autoMoorCalculating = false;
      }
      errorCallback();
      console.log(error);
    },
  );
};
